export const HEIGHT_UPDATE = 'height_update';
export const WIDTH_UPDATE = 'width_update';
export const VIEW_MODE_UPDATE = 'view_mode_update'